import FolderOverview from 'scoreboard/components/folder-overview'
import permissions from 'scoreboard/components/permissions'
import appDisplay from 'scoreboard/components/app-display'
import BriefingsNav from './briefings-nav'
import $ from 'jquery'

var BriefingsFolderOverview = FolderOverview.extend({

	_sendToOptions: [],

	allowEdit: function() {
		return permissions.briefings(this.model.get('organizationId'))
	},

	navigate: function(e) {
		let id = $(e.currentTarget).data('id')
		// #22853 make sure the briefings nav is used if we switched to a new
		// section. This is maybe not the best place for this fix, but we're
		// close to a release and I don't really understand the other code
		appDisplay.nav(BriefingsNav, { id })
		FolderOverview.prototype.navigate.apply(this, arguments)
	}

})

export default BriefingsFolderOverview

BriefingsFolderOverview.__filename__ = 'briefings/briefings-folder-overview.js'
